export default "__VITE_ASSET__if8bDfOC__"